<template>
  <div>
    <div class="head flex-center">
      <img class="logo" src="../../assets/home/bobo@2x.png" alt="" />
      <div class="flex-center" @click="$router.push('/search')">
        <img src="../../assets/home/search@2x.png" alt="" />
        <span>搜索</span>
      </div>
    </div>
    <div class="lunbo">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in lunbo" :key="item.id">
          <img :src="item.src" alt="" srcset="" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <van-tabs v-model="active" @click="onClick">
      <van-tab
        :title="item.title"
        v-for="item in navList"
        :key="item.id"
        :name="item.id"
      ></van-tab>
    </van-tabs>
    <!-- <simple-scroll-list
      class="list-body"
      v-model="loading"
      :finished="finished"
	  :closeLoad = "closeLoad"
      @load="onLoad"
    > -->
	<van-list
	  v-model="loading"
	  :finished="finished"
	  finished-text="没有更多了"
	  @load="onLoad"
	  class="simple-scroll-list list-body"
	>
      <div class="content" v-if="showLeve2">
        <div
          class="list borderBox"
          :class="{
            'show-item': show,
            selected: item.id == level2Selete,
          }"
          v-for="item in level2List"
          :key="item.id"
          @click="selectLevel2(item)"
        >
          <!-- <img :src="item.thumb" alt="" /> -->
          <p>{{ item.title }}</p>
        </div>
        <div
          :class="{ list: true, 'showItem': !show }"
          v-if="!show&&level2List.length>0"
          @click="show = true"
        >
          <img src="../../assets/home/zhankai@2x.png" alt="" />
          <p>展开</p>
        </div>
        <div
          :class="{ list: true, 'showItem': show }"
          v-if="show&&level2List.length>0"
          @click="show = false"
        >
          <img src="../../assets/home/shouqi@2x (1).png" alt="" />
          <p>收起</p>
        </div>
      </div>
	  <van-pull-refresh v-model="loading" @refresh="refreshGetList">
      <div class="recom">
        <div class="lists">
          <router-link
            :to="`/classify/commodity/details/${item.id}`"
            class="list"
            v-for="item in list"
            :key="item.id"
          >
			<img v-if="item.status == 'sold_out'" src="../../assets/home/sold.png" class="soldIcon" />
            <!-- <img v-lazy="item.thumb" alt="" /> -->
			    <img :src="item.thumb" alt=""   />
            <p>{{item.title}}</p>
            <div>¥{{item.realPrice}}</div>
          </router-link>
        </div>
      </div>
	  </van-pull-refresh>
    <!-- </simple-scroll-list> -->
	</van-list>
  </div>
</template>
<script>
import SimpleScrollList from "../../components/SimpleScrollList.vue";
export default {
  name:'home',
  data() {
	
    return {
      show: false,
      lunbo: [
        {
          img: require("../../assets/home/pic@2x (2).png"),
        },
        {
          img: require("../../assets/home/pic@2x (2).png"),
        },
      ],
      active: 0,
      showLeve2: false,
      navList: [
        {
          title: "特惠商品",
          id: -1,
        },
      ],
      level2List: [],
      level2Selete: -1,
      form: {
        lastId: 0, // 必选 最新ID。首次传0，之后传接口返回的lastId
        page: 0, // 必选 请求数据页码
        condition: {
          categoryId: 0, // 商品分类ID。若不指定分类则传0
          // floor: 0, // 分类层级
          // orderField: "", // 排序的字段。默认传空字符串，按销量排序：sale；按价格排序：price
          // priceOrder: "", // 价格排序方向。升序：up；降序：down
          // isRecommend: null, // 是否为精品推荐。是：true；否：false。
          // isHot: null, // 是否为热卖。是：true；否：false。
          // isNew: null, // 是否为新品。是：true；否：false。
        }, // 必选 搜索条件
      },
      recommendedForm: {
        lastId: 0, // 必选 最新ID。首次传0，之后传接口返回的lastId
        page: 1, // 必选 请求数据页码
        condition: {
          // categoryId: 0, // 商品分类ID。若不指定分类则传0
          // floor: 0, // 分类层级
          // orderField: "", // 排序的字段。默认传空字符串，按销量排序：sale；按价格排序：price
          // priceOrder: "", // 价格排序方向。升序：up；降序：down
          isRecommend: true, // 是否为精品推荐。是：true；否：false。
          // isHot: null, // 是否为热卖。是：true；否：false。
          // isNew: null, // 是否为新品。是：true；否：false。
        }, // 必选 搜索条件
      },
      selfForm: {
        lastId: 0, // 必选 最新ID。首次传0，之后传接口返回的lastId
        page: 1, // 必选 请求数据页码
        condition: {
          code: 'self',
          // categoryId: 0, // 商品分类ID。若不指定分类则传0
          // floor: 0, // 分类层级
          // orderField: "", // 排序的字段。默认传空字符串，按销量排序：sale；按价格排序：price
          // priceOrder: "", // 价格排序方向。升序：up；降序：down
          // isRecommend: true, // 是否为精品推荐。是：true；否：false。
          // isHot: null, // 是否为热卖。是：true；否：false。
          // isNew: null, // 是否为新品。是：true；否：false。
        }, // 必选 搜索条件
      },
      list: [],
      loading: true,
      finished: false,
	    closeLoad:true,
    };
  },
  pass: true,
  beforeRouteLeave(to, from, next) {
    // console.log(document.documentElement.scrollTop,document.body.scrollTop,window.pageYOffset,222)
	  this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  	   // 设置下一个路由的 meta
	   // console.log(this.scrollTop,333)
  	  to.meta.keepAlive = false;  // 让 A 缓存，即不刷新
	  if(to.name=='classifyCommoditydetails'){
		  from.meta.keepAlive = true;  // 让 A 缓存，即不刷新
	  }else{
		  from.meta.keepAlive = false;  // 让 A 缓存，即不刷新
	  }
	  this.closeLoad != this.closeLoad
	  // from.meta.keepAlive = false;
  	  next();
  },
  beforeRouteEnter(to,from,next){
	// if(to.name=='details'){
	// 	to.meta.keepAlive = true;  // 让 A 缓存，即不刷新
	// }else{
	// 	to.meta.keepAlive = false;  // 让 A 缓存，即不刷新
	// }
	next(vm =>{
		// console.log(vm.scrollTop,444)
		document.body.scrollTop = vm.scrollTop;
	})  
  },
  methods: {
	  // 请求banner
	selectBanner(){
		this.$post({
		  url: "/portal",
		  module: "Content",
		  interface: "1000",
		  data: {
		    position:'m_shop_home_top',
		  },
		}).then((res) => {
		  // console.log("二级分类", res);
		  this.lunbo = res.list
		});
	},
	getInfo() {
	  this.$post({
	    module: "User",
	    interface: "1000",
	    data: {},
	  }).then((res) => {
		  localStorage.setItem('mobile',res.mobile)
		  if(localStorage.getItem('mobile')==null){
		  	// localStorage.setItem('mobile',res.mobile)
		  	
		  	this.$dialog.alert({
		  	  title: '提示',
		  	  message: '您尚未绑定手机号，不能购买商品，是否前去绑定？',
		  	  showCancelButton:true,
		  	  confirmButtonText:'前去绑定'
		  	}).then(() => {
		  	  this.$router.push('/my/phone')
		  	  
		  	});
		  }
		
	    // this.info = res;
	  });
	},
    onLoad() {
		if(this.active==-1){
			 
			if(this.recommendedForm.page != 1){
				this.getRecommend();
			}
			
		}else{
			if(this.form.page != 1){
				this.getList();
			}
			
		}
      
    },
    onClick(id) {
      if (id == -1) { //推荐商品
        this.showLeve2 = false;
        this.recommendedForm.page = 1;
        this.recommendedForm.lastId = 0;
        this.getRecommend();
      } else if (id == -2) {
        //自营商品
        this.showLeve2 = false;
        this.selfForm.page = 1;
        this.selfForm.lastId = 0;
        this.getSelfList();
      } else {
        this.getList(id, 1);
        this.getLevel2(id);
      }
    },
    selectLevel2(item) {
      this.level2Selete = item.id;
      this.getList(item.id, 2);
    },
    getLevel2(parentId) {
      this.$post({
        url: "/portal/Shop",
        module: "GoodsCategory",
        interface: "1003",
        data: {
          parentId,
        },
      }).then((res) => {
        // console.log("二级分类", res);
        this.level2Selete = -1;
        this.level2List = res.list;
        this.showLeve2 = true;
        // this.navList = this.navList.concat(res.list);
      });
    },
    getList(id, floor) {
      if (id && floor) {
        this.form.page = 1;
        this.form.lastId = 0;
        this.form.condition.categoryId = id;
        this.form.condition.floor = floor;
        this.list = [];
        this.loading = true;
        this.finished = false;
      }
      this.$post({
        url: "/portal/Shop",
        module: "Goods",
        interface: "1001",
        data: this.form,
      }).then((res) => {
        // console.log("商品列表", res);
        this.form.lastId = res.lastId;
        this.form.page++;
        this.finished = res.list.length < 1;
		console.log(2,this.finished)
        this.list = this.list.concat(res.list);
        this.loading = false;
      });
    },
	// PullRefresh 刷新
	refreshGetList() {
	    this.form.page = 1;
	    this.form.lastId = 0;
	    
	  this.$post({
	    url: "/portal/Shop",
	    module: "Goods",
	    interface: "1001",
	    data: this.form,
	  }).then((res) => {
	    // console.log("商品列表", res);
	    this.form.lastId = res.lastId;
	    this.form.page++;
	    this.finished = res.currentPage >= 1;
	    this.list = res.list;
	    this.loading = false;
	  });
	},
    getLevel1() {
      this.$post({
        url: "/portal/Shop",
        module: "GoodsCategory",
        interface: "1001",
        data: {},
      }).then((res) => {
        // console.log("一级分类", res);
        this.navList = this.navList.concat(res.list);
      });
    },
	  // 查询推荐
    getRecommend() {
	    this.list = [];
      this.$post({
        url: "/portal/Shop",
        module: "Goods",
        interface: "1001",
        data: this.recommendedForm,
      }).then((res) => {
        // console.log("推荐列表", res);
        this.recommendedForm.lastId = res.lastId;
        this.recommendedForm.page++;
        this.list = this.list.concat(res.list);
        this.finished = true;
        this.loading = false;
      });
    },
    //查询自营
    getSelfList() {
	    this.list = [];
      this.$post({
        url: "/portal/Shop",
        module: "Goods",
        interface: "1001",
        data: this.selfForm,
      }).then((res) => {
        console.log("自营列表", res);
        this.selfForm.lastId = res.lastId;
        this.selfForm.page++;
        this.list = this.list.concat(res.list);
        this.finished = true;
        this.loading = false;
      });
    },
    parseURL(url) {
      var a = document.createElement('a');
      a.href = url;
      return {
          source: url,
          protocol: a.protocol.replace(':',''),
          host: a.hostname,
          port: a.port,
          query: a.search,
          params: (function(){
              var ret = {},
              seg = a.search.replace(/^\?/,'').split('&'),
              len = seg.length, i = 0, s;
              for (;i<len;i++) {
                  if (!seg[i]) { continue; }
                  s = seg[i].split('=');
                  ret[s[0]] = s[1];
              }
              return ret;
          })(),
          file: (a.pathname.match(/\/([^\/?#]+)$/i) || [,''])[1],
          hash: a.hash.replace('#',''),
          path: a.pathname.replace(/^([^\/])/,'/$1'),
          relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [,''])[1],
          segments: a.pathname.replace(/^\//,'').split('/')
      };
    }
  },
  created() {
    // var url_list = this.parseURL(window.location.href);

    // 创建URL对象
    var url = new URL(window.location.href);

    // 获取 URLSearchParams 对象
    var searchParams = url.searchParams;

    // 获取参数值
    // var time = searchParams.get('time');
    var path = searchParams.get('path');
    // var shareUserId = searchParams.get('shareUserId');

    console.log(searchParams)

    // console.log(url_list);

    if(path != undefined) {
      this.$router.push(path)
    }else{
      this.selectBanner()
      this.getLevel1();
      this.getRecommend();
      
      console.log(localStorage.getItem('mobile'))
      if(localStorage.getItem('mobile')==null){
        this.getInfo()
      }

    }

    // this.showLeve2 = false;
    // this.selfForm.page = 1;
    // this.selfForm.lastId = 0;
    // this.getSelfList();

    // this.getList(-1, 1);
    // this.getLevel2(1);
    

  },
  
  // destroyed(){
	 //  console.log(1)
  // 	this.closeLoad != this.closeLoad
  // },
  components: {
    SimpleScrollList,
  },
};
</script>

<style scoped lang="less">
/deep/ .van-pull-refresh__track{
	    width: 100%;
	    display: flex;
	    justify-content: space-between;
	    flex-wrap: wrap;
	    align-items: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.head {
  height: 90px;
  padding: 0 10px;
  background: #ff4c66;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;

  .logo {
    width: 84px;
    height: 26px;
  }
  div {
    width: 258px;
    height: 30px;
    background: #ffb7c1;
    border-radius: 15px;
    margin-left: 10px;
    img {
      width: 22px;
      height: 22px;
      margin-left: 5px;
    }
    font-size: 14px;
    color: #fd0212;
    span {
      margin-left: 5px;
    }
  }
}

.lunbo {
  padding-top: 90px;
  img {
    height: 200px;
    width: 100%;
  }
}

.list-body {
  height: calc(100vh - 184px);
  // overflow: auto;
}

.lists {
  padding: 0 16px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .list {
    width: 48%;
    margin-top: 20px;
	position:relative;
    div {
      color: #f50152;
    }
    p {
      color: #333333;
      font-size: 14px;
      line-height: 30px;
    }
	
    img {
      width: 160px;
      height: 160px;
    }
	.soldIcon{
		position:absolute;
		top:0;
		left:0;
		height:44px;
		width:44px;
	}
  }
}
.content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  // .borderBox{
	  // border:1px solid #e0e0e1;
  // }
  .list {
    width: calc(25% - 5px);
    text-align: center;
    // padding-top: 10px;
    display: none;
	padding-top:10px;
    color: #666;
	// border:1px solid #e0e0e1;
	// margin:10px 5px;
    &.selected {
      background-color: #f501521e;
      border-radius: 6px;
    }
    img {
      width: 48px;
      height: 48px;
    }
    p {
      font-size: 12px;
    }
  }
  .list:nth-child(-n + 7),
  .show-item {
    display: unset;
  }
  .showItem{
	  display:flex;
	  align-items: center;
  }
}
</style>
